module.exports = __webpack_public_path__ + "static/media/courtyard.fcf2a91e.png";